import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiGrid, FiCalendar, FiTarget, FiImage, FiSettings, FiPlayCircle } from 'react-icons/fi';

const navItems = [
  { path: '/', icon: FiGrid, label: 'Dashboard' },
  { path: '/orbit', icon: FiTarget, label: 'Campaign Orbit' },
  { path: '/calendar', icon: FiCalendar, label: 'Calendar Grid' },
  { path: '/assets', icon: FiImage, label: 'Asset Library' },
  { path: '/demo', icon: FiPlayCircle, label: 'Demo' },
  { path: '/settings', icon: FiSettings, label: 'Settings' },
];

export default function Sidebar() {
  return (
    <aside className="w-64 h-screen border-r border-[#1a1a1a] bg-[#0a0a0a] flex flex-col justify-between shrink-0 relative z-20">
      <div>
        <div className="p-6 flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#FF5A5F] to-[#ff2a30] flex items-center justify-center shadow-[0_0_15px_rgba(255,90,95,0.4)]">
            <SafeIcon icon={FiTarget} className="text-white text-xl" />
          </div>
          <h1 className="text-xl font-bold tracking-wider text-white">
            Content<span className="text-[#FF5A5F]">Orbit</span>
          </h1>
        </div>

        <nav className="px-4 mt-6 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <SafeIcon icon={item.icon} className="text-lg" />
              <span className="font-medium text-sm tracking-wide">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="p-6 border-t border-[#1a1a1a]">
        <div className="flex items-center gap-3 mb-6 px-2">
          <img src="https://i.pravatar.cc/150?img=32" alt="User" className="w-10 h-10 rounded-full border border-[#2a2a2a]" />
          <div>
            <p className="text-sm font-medium text-white">Elena Rostova</p>
            <p className="text-xs text-gray-500">Content Lead</p>
          </div>
        </div>
        
        <div className="text-center mt-8">
          <p className="text-[10px] text-gray-600 uppercase tracking-widest">
            Made by <br/> LingLink AI and DigLab AI
          </p>
        </div>
      </div>
    </aside>
  );
}